import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import React, { useState } from "react";
import { formatCurrency, formatDate } from "../../../utils/utils";
import { tableCellStyles, tableHeaderStyles } from "../../../utils/styles";

const VehicleExpenseDetails = ({ data }: { data: any }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const records = data?.records || [];
  const paginatedRecords = records.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeaderStyles}>Expense Date</TableCell>
              <TableCell sx={tableHeaderStyles}>Expense Type</TableCell>
              <TableCell sx={tableHeaderStyles}>Amount</TableCell>
              <TableCell sx={tableHeaderStyles}>Paid</TableCell>
              <TableCell sx={tableHeaderStyles}>Balance</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRecords.length > 0 ? (
              paginatedRecords.map((vehicleExpense: any) => (
                <TableRow key={vehicleExpense.id}>
                  <TableCell sx={tableCellStyles}>
                    {formatDate(vehicleExpense.expenseDate)}
                  </TableCell>
                  <TableCell sx={tableCellStyles}>
                    {vehicleExpense.expenseType}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles, color: "error.main" }}>
                    {formatCurrency(vehicleExpense.amount)}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...tableCellStyles,
                      color: "success.main",
                    }}
                  >
                    {formatCurrency(vehicleExpense.paidAmount)}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...tableCellStyles,
                      color:
                        Number(vehicleExpense.balance) > 0
                          ? "error.main"
                          : "success.main",
                    }}
                  >
                    {formatCurrency(vehicleExpense.balance)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} sx={{ textAlign: "center" }}>
                  No vehicle expense record found for this vehicle
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {records.length > 10 && (
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={records.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )}
    </Paper>
  );
};

export default VehicleExpenseDetails;
